<template>
  <div v-if="isLoading" :class="['loading-wave', { 'is-active': isActive }]">
    <div class="loading-bar"></div>
    <div class="loading-bar"></div>
    <div class="loading-bar"></div>
    <div class="loading-bar"></div>
    <div class="loading-bar"></div>
  </div>
</template>

<script>
export default {
  name: "BarLoader",

  props: {
    isLoading: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      isActive: false,
      activateTimer: null
    };
  },
  watch: {
    isLoading(newVal) {
      if (newVal) {
        this.isActive = false;
        setTimeout(() => {
          this.isActive = true;
        }, 10);
      } else {
        this.isActive = false;
      }
    }
  },
  mounted() {
    if (this.isLoading) {
      setTimeout(() => {
        this.isActive = true;
      }, 10);
    }
  }
};
</script>


<style scoped>
.loading-wave {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 50px 0;
  opacity: 0;
}

.loading-wave.is-active {
  opacity: 1;
  transition: opacity 1s ease-in;
}

.loading-bar {
  width: 3px;
  height: 16px;
  margin: 0 2px;
  border-radius: 5px;
  background-color: #0779c5;
  animation: loading-wave-animation 1s ease-in-out infinite;
}

.loading-bar:nth-child(2) {
  animation-delay: 0.1s;
}

.loading-bar:nth-child(3) {
  animation-delay: 0.2s;
}

.loading-bar:nth-child(4) {
  animation-delay: 0.3s;
}

@keyframes loading-wave-animation {
  0% {
    transform: scaleY(0.1);
    background-color: #0779c5;
  }

  50% {
    transform: scaleY(1);
    background-color: #3498db;
  }

  100% {
    transform: scaleY(0.1);
    background-color: #0779c5;
  }
}
</style>
